import { useAtom } from 'jotai';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Libs
import { alternativeWinnersOptions } from '@/lib/giveawayPicker/options';

// Components
import { Select } from '@/components/base/Select/SelectComponent';
// Atoms
import {
    optionsAtom,
    toggleAlternativeWinnersAtom
} from '@/components/pages/giveaway-picker/Atoms/OptionsAtoms';
import { ToggleOption } from '@/components/pages/giveaway-picker/OptionsWrapper/components/ToggleOption';

const optionsAlternativeWinners = alternativeWinnersOptions;

export const AlternativeWinners = () => {
    const { t } = useTranslation('giveaway_picker');
    const [toggle, setToggle] = useAtom(toggleAlternativeWinnersAtom);
    const [options, setOption] = useAtom(optionsAtom);

    return (
        <ToggleOption
            title={t('options.alternative_winners')}
            subtitle={t('options.select_number_of_alternative_winners')}
            toggle={toggle}
            data-testid="alternative-winners-toggle"
            onToggle={() => {
                if (toggle) {
                    setOption((prev) => ({
                        ...prev,
                        nb_extraWinners: null
                    }));
                } else {
                    setOption((prev) => ({
                        ...prev,
                        nb_extraWinners: 1
                    }));
                }
                setToggle(!toggle);
            }}>
            <Select
                className="w-full"
                selected={optionsAlternativeWinners.find(
                    (option) => option.value === options.nb_extraWinners
                )}
                setSelected={(option) =>
                    setOption((prev) => ({
                        ...prev,
                        nb_extraWinners: option.value
                    }))
                }
                options={optionsAlternativeWinners}
                data-testid="alternative-winners"
            />
        </ToggleOption>
    );
};
